// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Trash } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconTrash(props: any) {
    return <IconBase icon={Trash} {...props} />
  }

  export default IconTrash
  